// ===================== component import =================== //
import React,{useEffect, useState, useContext, useRef} from 'react'
import { useNavigate, Navigate, Link  } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
// =================== Module import =============== //
import { toAbsoluteUrl } from "../../../_template/helpers/CommonFunction";
import  AppContext  from '../../routing/AuthContext';

// ================= component import ============== //
import { storePermission } from '../../redux/managePermissionSlice';
import ValidationMessage from '../../component/common/ValidationMessage';
import ButtonLoader from '../../component/common/ButtonLoader';
import AlertMessage from '../../component/common/AlertMessage';
import { getSubdomain, safeDecrypt, ValidateEmail } from '../../component/common/Helper';

const Login = (props) => {
    const authCtx = useContext( AppContext );
    const navigate = useNavigate();
    useEffect(() => {
        document.body.style.backgroundImage =  `url('${toAbsoluteUrl('media/auth/bg10.jpeg')}')`;
    },[])
    const api_base_url = process.env.REACT_APP_API_URL;

    // ------ get subdomain -------- //

    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const subdomain = (parts.length > 2) ? parts[0] : '';

    // ------------ password shown and hide ------------- //
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }
    // ---------- login submit ------------ //
    const [loginFormErorr, setLoginFormError] = useState({});
    const [loginFormData, setLoginFormData] = useState({
        username : "", 
        password : "" ,
    });
    const [resetPasswordBtnLoader, setResetPasswordBtnLoader] = useState(false);

    const validateField = (name, value) => {
        let error = "";
        if (name === "username") {
            if (!value) {
                error = "Email is required";
            } 
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        return error;
    };
    const inputChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateField(name, value);
        setLoginFormError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setLoginFormData((prevData) => ({
            ...prevData,
            [name]: value.trim(),
        }));
    }
    const username = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    const applicationUrl = localStorage.getItem('subdomain');
    
    const [isCheckedValue, setIsCheckedValue] = useState(false);
    useEffect(() => {
        const savedUser = Cookies.get('rememberUsername');
        const savedPass = Cookies.get('rememberPassword');
        if (savedUser) {
            setIsCheckedValue(true)
            setLoginFormData({
                username : savedUser, 
                password : savedPass ,
            })
        }
    },[])
    const handleCheckboxChange = (event) => {
        setIsCheckedValue(event.target.checked);
    };
    const [ loginResponse, setLoginResponse ] = useState({
        res_type : '',
        title : '',
        sub_title : '',
    });
    const [isShowButtonLoader, setIsButtonLoader] = useState(false);
    const loginSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in loginFormData) {
            newErrors[key] = validateField(key, loginFormData[key]);
        }
        setLoginFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setIsButtonLoader(true)
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            loginFormData.sass_id = localStorage.getItem('sass_id');
            loginFormData.sub_domain = localStorage.getItem('subdomain');

            await axios.post(`${api_base_url}api/login`, loginFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setLoginResponse({
                        res_type : 'success',
                        title : 'Authentication verified',
                        sub_title : res.data.message,
                    })

                    const _data = res.data.data;
                    if(!subdomain){
                        localStorage.setItem('sass_id', _data.data.sass_id);
                        localStorage.setItem('subdomain', _data.sub_domain);
                        localStorage.setItem('business_name', _data.business_name);
                        localStorage.setItem('business_email', _data.business_email);
                    }
                    setLoginFormError({});
                    localStorage.setItem('loginInfo', JSON.stringify(_data.data));
                    localStorage.setItem('username' , loginFormData.username)
                    localStorage.setItem('password' , loginFormData.password)
                    if(isCheckedValue){
                        Cookies.set('rememberUsername', loginFormData.username, { expires: 7 });
                        Cookies.set('rememberPassword', loginFormData.password, { expires: 7 });
                    }else{
                        Cookies.remove('rememberUsername');
                        Cookies.remove('rememberPassword');
                    }
                    if(res.data.data.user_type === "E") {
                        localStorage.setItem('agent_id' , res.data.data.data.unique_id)
                    }
                    setTimeout(() => {
                        authCtx.login({
                            token : res.data.data.token, 
                            type: res.data.data.user_type,
                            loginData: JSON.stringify(res.data.data.data)
                        })
                        setLoginFormData({
                            username : "", 
                            password : "" ,
                        });
                    }, 1000);
                } else if(res.data.status === 'error') {
                    setLoginResponse({
                        res_type : 'danger',
                        title : 'Failed',
                        sub_title : res.data.message,
                    })
                }
            })
            .catch((error) => {
                console.error(error);
            })
            setIsButtonLoader(false)
        }
    }

    const [showResetForm, setShowResetForm] = useState(false);
    const [showOtpForm, setShowOtpForm] = useState(false);
    const [newPasswordForm, setNewPasswordForm] = useState(false);

    const [otpToken, setOtpToken] = useState(null);
    const [resetFormData, setResetFormData] = useState({
        subdomain: '',
        userEmail : "", 
        isValid : true
    });
    const [newPasswordFormData, setNewPasswordFormData] = useState({
        new_password: '',
        confirm_password : "", 
        isValidNewPassword : true,
        isValidNewConfirmPassword : true,
        subdomain: '',
        user_name: ''
    });
    const [verificationValus, setVerificationValus] = useState(['', '', '', '', '']);
    const [newPasswordShown, setNewPasswordShown] = useState(false);
    const [confirmPasswordShown, setConfirmPasswordShown] = useState(false);

    const handelEmail = (text) => {
        if(text.target.value) {
            setResetFormData({
                userEmail : text.target.value, 
                isValid : ValidateEmail(text.target.value)
            });
        } else {
            setResetFormData({
                userEmail : '', 
                isValid : false
            })
        }
    }
    const sendOTP = async() => {
        if(resetFormData.userEmail) {
            setResetPasswordBtnLoader(true)
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            resetFormData.subdomain = subdomain ? subdomain : localStorage.getItem('subdomain');
            await axios.post(`${api_base_url}api/check-login-email`, resetFormData, api_headers)
            .then(async (res) => {
                setResetPasswordBtnLoader(false)
                if(res.data.status === 'success') {
                    const _token = res.data.data._token
                    const decrypted = safeDecrypt({
                        encryptedData : _token,
                        base64Key : 'gT#7@uZ$9LmR8qV1',
                        base64Iv : 'X7r#zP@9gL!q1VbT'
                    });
                    setOtpToken(decrypted);
                    setShowOtpForm(true);
                } else if(res.data.status === 'error') {
                    setLoginResponse({
                        res_type : 'danger',
                        title : 'Failed',
                        sub_title : res.data.message,
                    })
                }
            })
            .catch((error) => {
                setResetPasswordBtnLoader(false)
                console.error(error);
            })
        } else {
            setResetFormData({
                userEmail : '', 
                isValid : false
            })
        }
    }
    const inputRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];
    const handleChange = (e, index) => {
        const value = e.target.value;

        if (!/^\d?$/.test(value)) return;

        const newValues = [...verificationValus];
        newValues[index] = value;
        setVerificationValus(newValues);

        if (value && index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !verificationValus[index] && index > 0) {
            const newValues = [...verificationValus];
            newValues[index - 1] = '';
            setVerificationValus(newValues);
            inputRefs[index - 1].current.focus();
        }
    };
    const validedOtp = () => {
        const enteredValue = verificationValus.join('');
        if(enteredValue === otpToken) {
            setNewPasswordForm(true);
            setLoginResponse({
                res_type : '',
                title : '',
                sub_title : "",
            })
        } else {
            setLoginResponse({
                res_type : 'danger',
                title : 'Failed',
                sub_title : "OTP not match",
            })
        }
    }
    const newPasswordInputChangeHandler = (text) => {
        if(text.target.value){
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                new_password: text.target.value,
                isValidNewPassword: true,
            }));
        } else {
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                new_password: '',
                isValidNewPassword: false,
            }));
        }
    }
    const confirmPasswordInputChangeHandler = (text) => {
        if(text.target.value){
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                confirm_password: text.target.value,
                isValidNewConfirmPassword: true,
            }));
        } else {
            setNewPasswordFormData((prevData) => ({
                ...prevData,
                confirm_password: '',
                isValidNewConfirmPassword: false,
            }));
        }
    }
    const toggleNewPasswordVisibility = () => {
        setNewPasswordShown(!newPasswordShown)
    }
    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordShown(!confirmPasswordShown)
    }
    const newPasswordSubmit = async() => {
        if(newPasswordFormData.new_password != '' && newPasswordFormData.confirm_password != '') {
            if((newPasswordFormData.new_password === newPasswordFormData.confirm_password) && resetFormData.userEmail) {
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                    }
                };
                newPasswordFormData.subdomain = subdomain ? subdomain : localStorage.getItem('subdomain');
                newPasswordFormData.user_name = resetFormData.userEmail;
                await axios.post(`${api_base_url}api/new-password-generate`, newPasswordFormData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        setLoginResponse({
                            res_type : 'success',
                            title : 'Password Reset',
                            sub_title : "Password successfully reset",
                        })
                        setTimeout(() => {
                            setShowResetForm(false);
                            setShowOtpForm(false);
                            setNewPasswordForm(false);

                            setLoginResponse({
                                res_type : '',
                                title : '',
                                sub_title : "",
                            })
                        }, 1000);
                    } else if(res.data.status === 'error') {
                        setLoginResponse({
                            res_type : 'danger',
                            title : 'Failed',
                            sub_title : res.data.message,
                        })
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            } else {
                setLoginResponse({
                    res_type : 'danger',
                    title : 'Failed',
                    sub_title : "Confirm password are not match with new password",
                })
            }
        } else {
            if(newPasswordFormData.new_password.trim() == '') {
                setNewPasswordFormData((prevData) => ({
                    ...prevData,
                    isValidNewPassword: false,
                }));
            }

            if(newPasswordFormData.confirm_password == '') {
                setNewPasswordFormData((prevData) => ({
                    ...prevData,
                    isValidNewConfirmPassword: false,
                }));
            }
        }
    }
    // ------------- check subdomain ------------ //
    const checkSubdomainRef = useRef();
    const [subdomainLoaderBtn, setSubdomainLoaderBtn] = useState(false);
    const [checkSubdomainForm, setCheckSubdomainForm] = useState({
        sub_domain: "",
    });
    const [subdomainFrmError, setSubdomainFrmError] = useState({});

    const _hostname = window.location.hostname;

    const validateSubdomain = (name, value) => {
        let error = "";
        if (name === "sub_domain") {
            if (!value) {
                error = "Application url & business id is required";
            }
        }
        return error;
    };
    const subdomainChangeHandler = (event) => {
        const { name, value } = event.target;
        const fieldError = validateSubdomain(name, value);
        setSubdomainFrmError((prevErrors) => ({
            ...prevErrors,
            [name]: fieldError,
        }));
        setCheckSubdomainForm((prevData) => ({
            ...prevData,
            [name]: value.trim(),
        }));
    }
    const checkSubdomainOnClick = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in checkSubdomainForm) {
            newErrors[key] = validateSubdomain(key, checkSubdomainForm[key]);
        }
        setSubdomainFrmError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            setSubdomainLoaderBtn(true)
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                }
            };
            await axios.post(`${api_base_url}api/subdomain-validate`, checkSubdomainForm, api_headers)
            .then(async (res) => {
                setSubdomainLoaderBtn(false)
                if(res.data.status === 'success') {
                    const _data = res.data.data;
                    if(_data.business_data.length === 0){
                        setLoginResponse({
                            res_type : 'danger',
                            title : 'Invalid input',
                            sub_title : 'Your input in invalid. Please check or try again.',
                        })
                    }
                    else{
                        const _protocol = window.location.protocol;
                        const _subdomainName = _data.business_data[0].biz_app_url;
                        const _makeUrl = `${_protocol}//${_subdomainName}.${_hostname}`;
                        window.location.href = _makeUrl;
                    }
                } else if(res.data.status === 'error') {
                    toast.error("There is an error");
                }
            })
            .catch((error) => {
                console.error(error);
                setSubdomainLoaderBtn(false)
            })
        }
    }
    const keyDown = (event) => {
        if (event.key === "Enter") {
            if (checkSubdomainRef.current) {
                checkSubdomainRef.current.click();
            }
        }
    }
    return (
        <>
            {/* ================== new ================ */}
            <div className="d-flex flex-column flex-root min-vh-100" style={{background:'white'}}>
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                            <div className="w-lg-500px p-10">
                                <form className="form w-100" onSubmit={loginSubmitHandler}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="text-center mb-11">
                                                {
                                                    !showResetForm && 
                                                    <h1 className="text-dark fw-bolder mb-3 fs-2x">Sign In</h1>
                                                }
                                                {
                                                    showResetForm && 
                                                    !showOtpForm &&
                                                    <>
                                                        <h1 className="text-dark fw-bolder fs-2x">
                                                            Verification
                                                        </h1>
                                                        <span className="text-muted fw-semibold">
                                                            We will send you a One Time Password on your registered email ID
                                                        </span>
                                                    </>
                                                }
                                                {
                                                    showOtpForm && 
                                                    !newPasswordForm && 
                                                    <h1 className="text-dark fw-bolder mb-3 fs-2x">Verify OTP</h1>
                                                }
                                                {
                                                    showResetForm && 
                                                    showOtpForm && 
                                                    newPasswordForm && 
                                                    <h1 className="text-dark fw-bolder mb-3 fs-2x">
                                                        Enter new password
                                                    </h1>
                                                }
                                            </div>
                                        </div>
                                        {loginResponse.res_type != '' &&
                                            <div className='col-md-12'>
                                                <AlertMessage
                                                    type = {loginResponse.res_type}
                                                    title = {loginResponse.title}
                                                    sub_title = {loginResponse.sub_title}
                                                    border_type='dashed'
                                                />
                                            </div>
                                        }
                                        {
                                            subdomain === '' &&
                                            <>
                                                <div className="col-md-12 mb-8">
                                                    <div className="input-group">
                                                        <input 
                                                            type="text" 
                                                            placeholder="Enter application URL or business id" 
                                                            name="sub_domain" 
                                                            autoComplete="off" 
                                                            className={`form-control bg-transparent ${subdomainFrmError.sub_domain ? 'is-invalid' : ''}`}
                                                            style={{ height: '50px' }}
                                                            onChange={subdomainChangeHandler}
                                                            value={checkSubdomainForm.sub_domain}
                                                            onKeyDown={keyDown}
                                                        />
                                                    </div>
                                                    {subdomainFrmError.sub_domain && <ValidationMessage className='text-danger' message ={subdomainFrmError.sub_domain}/>}
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary ${subdomainLoaderBtn && 'disabled'}`} 
                                                            type="button"
                                                            onClick={checkSubdomainOnClick}
                                                            ref={checkSubdomainRef}
                                                        >
                                                            {
                                                                subdomainLoaderBtn ? 
                                                                <ButtonLoader btnHtml='Please wait...' className='me-2'/> : <span className="indicator-label">Enter</span>
                                                            }
                                                        </button>
                                                        <div className="text-gray-600 text-center fw-semibold fs-6 mt-5">
                                                            Don’t have an account yet?
								                            <Link
                                                                to={'/sign-up'}
                                                                className="link-primary ms-1"
                                                            >
                                                                Sign up 
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {
                                            subdomain !== '' &&
                                            !showResetForm && 
                                                <>
                                                    <div className="col-md-12">
                                                        <div className="fv-row mb-8">
                                                            <input
                                                                type="text" 
                                                                placeholder="Registered Email ID" 
                                                                name="username" 
                                                                autoComplete="off" 
                                                                className={`form-control bg-transparent ${loginFormErorr.username ? 'is-invalid' : ''}`}
                                                                style={{ height: '50px' }}
                                                                onChange={inputChangeHandler}
                                                                value={loginFormData.username}
                                                            />
                                                            {loginFormErorr.username && <ValidationMessage className='text-danger' message ={loginFormErorr.username}/>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="fv-row mb-8">
                                                            <div className="position-relative">
                                                                <input 
                                                                    className={`form-control bg-transparent ${!passwordShown ? 'inp-secure' : ''} ${loginFormErorr.password ? 'is-invalid' : ''}`} 
                                                                    type="text" 
                                                                    placeholder="Password" 
                                                                    name="password" 
                                                                    autoComplete="off" 
                                                                    style={{ height: '50px' }}
                                                                    onChange={inputChangeHandler}
                                                                    value={loginFormData.password}
                                                                />
                                                                {!loginFormErorr.password && 
                                                                    <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                        { !passwordShown && 
                                                                            <FontAwesomeIcon 
                                                                                icon={faEye} 
                                                                                className='fs-4 cursor-pointer text-gray-500'
                                                                                onClick={ togglePasswordVisibility }
                                                                            />
                                                                        }
                                                                        { passwordShown && 
                                                                            <FontAwesomeIcon 
                                                                                icon={faEyeSlash} 
                                                                                className='fs-4 cursor-pointer text-gray-500'
                                                                                onClick={ togglePasswordVisibility }
                                                                            />
                                                                        }
                                                                    </span>
                                                                }
                                                            </div>
                                                            {loginFormErorr.password && <ValidationMessage className='text-danger' message ={loginFormErorr.password}/>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-11">
                                                        <label className="form-check form-check-sm form-check-custom form-check-solid me-5 mb-8">
                                                            <input className="form-check-input" type="checkbox" value="1" checked={isCheckedValue} 
                                                            onChange={handleCheckboxChange}/>
                                                            <span className="form-check-label">Remember for next time</span>
                                                        </label>
                                                    </div>
                                                    <div className="col-md-12 text-center">
                                                        <div className="d-grid mb-10">
                                                            <button 
                                                                className={`btn btn-primary ${isShowButtonLoader && 'disabled'}`} 
                                                                type="submit"
                                                            >
                                                                {
                                                                    isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : <span className="indicator-label">Let's Go</span>
                                                                }
                                                            </button>
                                                        </div>
                                                        <span className="form-check-label">Don't remember password ?<span className="link-primary cursor-pointer" onClick={()=>setShowResetForm(true)}> Reset Now</span></span>
                                                    </div>
                                                </>
                                        }
                                        
                                        {showResetForm && !showOtpForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <input
                                                            type="email" 
                                                            placeholder="Enter your email" 
                                                            name="usernameEmail" 
                                                            autoComplete="off" 
                                                            className={`form-control bg-transparent ${!resetFormData.isValid ? 'is-invalid' : ''}`}
                                                            style={{ height: '50px' }}
                                                            onChange={handelEmail}
                                                            value={resetFormData.userEmail}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                            onClick={sendOTP}
                                                            disabled={resetPasswordBtnLoader}
                                                        >
                                                            {
                                                                resetPasswordBtnLoader ?
                                                                <ButtonLoader btnHtml='Please wait...' className='me-2'/>
                                                                :
                                                                <span className="indicator-label">GET OTP</span>
                                                            }
                                                        </button>
                                                    </div>
                                                    <span className="form-check-label">
                                                        Already have an account?
                                                        <span className='link-primary cursor-pointer ms-1' onClick={() => setShowResetForm(false)}>
                                                            Sign in
                                                        </span>
                                                    </span>
                                                </div>
                                            </>
                                        }
                                        {showOtpForm && !newPasswordForm && 
                                            <>
                                                <div className='col-md-12'>
                                                    <div className="mb-10">
                                                        <div className="fw-bold text-start text-dark fs-6 mb-1 ms-1">
                                                            Enter your 5 digit verification code
                                                        </div>
                                                        <div className="d-flex flex-wrap">
                                                            {inputRefs.map((ref, index) => (
                                                                <input
                                                                    className="form-control bg-transparent h-60px w-60px fs-2qx text-center mx-2 my-2"
                                                                    key={index}
                                                                    type="text"
                                                                    maxLength="1"
                                                                    inputMode="numeric"
                                                                    pattern="[0-9]*"
                                                                    ref={ref}
                                                                    onChange={(e) => handleChange(e, index)}
                                                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={validedOtp}>Valided OTP</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        {newPasswordForm && 
                                            <>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!newPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="New Password" 
                                                                name="new_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={newPasswordInputChangeHandler}
                                                                value={newPasswordFormData.new_password}
                                                            />
                                                            {newPasswordFormData.new_password && <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                { !newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEye} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                                { newPasswordShown && 
                                                                    <FontAwesomeIcon 
                                                                        icon={faEyeSlash} 
                                                                        className='fs-4 cursor-pointer text-gray-500'
                                                                        onClick={ toggleNewPasswordVisibility }
                                                                    />
                                                                }
                                                            </span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="fv-row mb-8">
                                                        <div className="position-relative">
                                                            <input 
                                                                className={`form-control bg-transparent ${!confirmPasswordShown ? 'inp-secure' : ''} ${!newPasswordFormData.isValidNewConfirmPassword ? 'is-invalid' : ''}`} 
                                                                type="text" 
                                                                placeholder="new Confirm Password" 
                                                                name="new_confirm_password" 
                                                                autoComplete="off" 
                                                                style={{ height: '50px' }}
                                                                onChange={confirmPasswordInputChangeHandler}
                                                                value={newPasswordFormData.confirm_password}
                                                            />
                                                            {newPasswordFormData.confirm_password && 
                                                                <span className="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2">
                                                                    { !confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEye} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                    { confirmPasswordShown && 
                                                                        <FontAwesomeIcon 
                                                                            icon={faEyeSlash} 
                                                                            className='fs-4 cursor-pointer text-gray-500'
                                                                            onClick={ toggleConfirmPasswordVisibility }
                                                                        />
                                                                    }
                                                                </span>
                                                            }
                                                        </div>
                                                        {/* {newPasswordFormData.isValidNewConfirmPassword && <ValidationMessage className='text-danger' message ={loginFormErorr.password}/>} */}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center">
                                                    <div className="d-grid mb-10">
                                                        <button 
                                                            className={`btn btn-primary`} 
                                                            type="button"
                                                        >
                                                            <span className="indicator-label" onClick={newPasswordSubmit}>Submit</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2" style={{backgroundImage: `linear-gradient(312deg, #ebecf8ff 11.58%, #eaeeffff 82.42%)`}}>
                        <div className="d-flex flex-column flex-center py-7 py-lg-15 w-100">
                            <div className="mb-0 mb-lg-12">
                                <img alt="Logo" src="/truvoice_logo-new.png" className="h-60px h-lg-75px"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login